/*
 * @Author: mqlpcthree mql_pcthree@163.com
 * @Date: 2024-03-26 10:28:16
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @LastEditTime: 2024-07-03 14:11:42
 * @FilePath: \mei_qi_zeroweb_endlyq\src\router\home\member.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// member
const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')
const MqlMiddlePage = () =>
  import(/* webpackChunkName: 'memberList' */ '@components/core/MqlLayout/MqlMiddlePage/index')
// const memberList = () => import(/* webpackChunkName: 'memberList' */ '@views/home/member/memberList/index')
// const memberImport = () => import(/* webpackChunkName: 'memberImport' */ '@views/home/member/memberImport/index')
// const memberDetail = () => import(/* webpackChunkName: 'memberDetail' */ '@views/home/member/memberDetail/index')

const routes = [
  {
    path: '/member',
    component: index,
    redirect: { name: 'memberList' },
    name: 'member',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '会员中心',
      first: true,
      resourceCode: 'MEMBER_SHIP',
      icon: 'member_ship',
      No: 2
    },
    children: [
      {
        path: 'item',
        component: MqlMiddlePage,
        redirect: { name: 'homeMemberItemList' },
        name: 'memberList',
        meta: {
          keepAlive: true,
          title: '会员列表',
          second: false,
          resourceCode: 'MEMBER_SHIP01',
          No: 0
        },
        children: [
          {
            path: 'list',
            component: () => import('@views/home/member/memberList/index'),
            name: 'homeMemberItemList',
            meta: { keepAlive: true, title: '会员列表', second: false, resourceCode: '', No: '' }
          },
          {
            path: 'detail',
            component: () => import('@views/home/member/memberDetail/index'),
            name: 'homeMemberItemDetail',
            meta: { keepAlive: true, title: '会员详情', second: false, resourceCode: '', No: '' }
          }
        ]
      },
      {
        path: 'Overview',
        component: () => import('@views/home/member/memberOverview/memberOverivew'),
        name: 'memberOverview',
        meta: {
          keepAlive: true,
          title: '会员概览',
          second: false,
          resourceCode: 'MEMBER_SHIP07',
          No: 3
        }
      },
      {
        path: 'import',
        component: () => import('@views/home/member/memberImport/index'),
        name: 'memberImport',
        meta: {
          keepAlive: true,
          title: '会员导入',
          second: false,
          resourceCode: 'MEMBER_SHIP02',
          No: 1
        }
      },
      {
        path: 'Tracking',
        component: () => import('@views/home/member/memberTrack/memberTrack'),
        name: 'memberTrack',
        meta: {
          keepAlive: true,
          title: '跟进记录',
          second: false,
          resourceCode: 'MEMBER_SHIP05',
          No: 2
        }
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/member.js